module.exports = __webpack_public_path__ + "static/media/slide-1.4853f9e6.webp";